import { type ButtonProps, Button as MuiButton } from '@mui/material'

export type TCounterofferButtonProps = Omit<ButtonProps, 'startIcon'> & {
  onClick: () => void
}

export const Button = ({ sx, ...props }: ButtonProps) => (
  <MuiButton
    disableElevation
    sx={{
      borderRadius: 100,
      fontWeight: 600,
      textTransform: 'none',
      px: 2,
      ...sx,
    }}
    {...props}
  />
)
